export default function getGroup(groups: any[]) {
    if (groups.length === 0) { return [] }
    const result = groups.map(group => {
        const obj: {
            value: any,
            label: any,
            children?: any[]
        } = {
            value: group.id,
            label: group.name
        }
        const children = group.secondary_group
            .map(secondaryGroup => {
                const temp = {
                    value: secondaryGroup.id,
                    label: secondaryGroup.name
                }
                return temp
            })
        if (children.length > 0) {
            obj.children = children
        }
        return obj
    })
    return result
}
